import { useRouter } from "next/router";

export const getCanonicalUrl = (context) => {
  const { req } = context;
  const protocol = req?.headers["x-forwarded-proto"] || "http";
  const host = req?.headers.host;
  const path = req?.url || "";

  return `${protocol}://${host}${path}`;
};

export const useCanonicalUrl = () => {
  const router = useRouter();
  const cleanUrl = (process.env.NEXT_PUBLIC_SITE_URL).replace(/\/$/, "");
  const baseUrl = cleanUrl || "https://www.simpolo.com";


  const resolvedPath = router.asPath.split("?")[0];

  const finalResolvedPath = resolvedPath == '/tiles/products/all-tiles' ? '/tiles/products' : resolvedPath;

  // const pathWithoutSlug = resolvedPath.split("/[")[0];
  const updatedPath = finalResolvedPath.replace(
    /^\/tiles\/products\/(.*?)\-collection$/,
    "/tiles/collection/$1"
  );
  return `${baseUrl}${updatedPath}`;
};
